import React, {createRef, RefObject} from 'react';

// @ts-ignore
import TaskStatusManager from '../../../gd/manager/task-status-manager';
import Popover from "../../../gd-components/gd-popover/popover";
import PopoverPosition from '../../../gd-components/gd-popover/popover-position';
import PopoverHelpHint from "../../../gd-components/popover-menu/popover-help-hint/popover-help-hint";
import PopoverMenuSeparator from "../../../gd-components/popover-menu/popover-menu/popover-menu-separator";
import PopoverMenuOptionStatus from "../../../gd-components/popover-menu/popover-menu/menu-option-status";
import TaskType from "../../../model2/task-type/task-type";


type Props = {

    getTarget           : any

    projectId           : ID,
    taskTypeId          : ID,

    hint                : boolean,   // if true - show hint messages

    doNotShowClosedStatuses : boolean,       // if true do not show closed / cancelled statuses - used in task reopen

    onStatusSelect      : onChangeCallback,

    hidePopover         : onChangeCallbackOptionalValue,
    togglePopover       : callback,

    // POPOVER ATTACHMENT
    popoverPosition     : PopoverPosition
}

export default class TaskStatusSelectorPopover extends React.Component<Props, any> {

    private refHintMessage  : RefObject<PopoverHelpHint>

    constructor(props:Props) {
        super(props);

        this.refHintMessage   = createRef()
    }

    onStatusClick = (statusId:ID) => {
        this.props.onStatusSelect(statusId)
    }

    onEditStatusesClick = () => {
        const { projectId, taskTypeId } = this.props;
        this.props.togglePopover()

        const statusesOverridden = TaskStatusManager.getProjectStatusesOverride(projectId).overridden;

        if (statusesOverridden) {
            gd.goTo('p/'+projectId+'/info/settings/workflow');
        } else {
            const taskType = gd.session.taskTypes.get(taskTypeId);
            if (taskType) {
                taskType.goToSettings()
            }

        }
    }

    handleHoverOn = (info:string) => {
        if (!this.props.hint) return

        this.refHintMessage?.current?.setMessage(info)
    }

    handleHoverOff = () => {
        if (!this.props.hint) return
        this.refHintMessage?.current?.setMessage(null)
    }

    render() {

        const { projectId, taskTypeId } = this.props;
        // const statusesOverridden = projectId ? TaskStatusManager.getProjectStatusesOverride(projectId).overridden : false;
        // const companyId = statusesOverridden ? gd.session.projects.get(projectId).companyId : gd.session.taskTypes.get(taskTypeId).companyId;

        let taskStatuses = TaskStatusManager.getTaskStatuses({projectId:projectId, taskTypeId:taskTypeId});

        if (this.props.doNotShowClosedStatuses) {
            taskStatuses = _.filter(taskStatuses,(status)=>status.systemStatus < 5)
        }


        const grouped = _.chain(taskStatuses)
            .orderBy(m=>m.systemStatus, 'asc')
            .groupBy(m=>{
                switch (m.systemStatus){
                    case 1:
                        return 'new';
                    case 2:
                    case 3:
                        return 'in-progress';
                }
                return 'closed';
            })
            .toPairs()
            .value();


        return (
            <Popover popoverClass="gd-select-status-popover"
                     attachment={this.props.popoverPosition.attachment}
                     targetAttachment={this.props.popoverPosition.targetAttachment}
                     targetOffset={this.props.popoverPosition.targetOffset}
                     attachmentType={this.props.popoverPosition.attachmentType}
                     constraints={this.props.popoverPosition.constrains}

                     onClickOutside={()=>{this.props.hidePopover()}}
                     getTargetFunc={this.props.getTarget}
                     heightRestriction="half-window-height">


                <div className="ui5-popover-menu with-help">

                    {grouped.map((group, key)=>{

                        const isLast = key === _.size(grouped) -1

                        return (
                            <div key={key} className="">
                                {group[1].map((taskStatus, key)=>{
                                    return <PopoverMenuOptionStatus key={key}
                                                                    status={taskStatus}
                                                                    onClick={this.onStatusClick.bind(this, taskStatus.id)}
                                                                    onMouseEnter={this.handleHoverOn.bind(this, taskStatus.description)}
                                                                    onMouseLeave={this.handleHoverOff}
                                    />
                                })}

                                {!isLast && <PopoverMenuSeparator />}

                            </div>
                        )
                    })}

                    {this.props.hint && <PopoverHelpHint ref={this.refHintMessage} defaultMessage={"Select task status"} className="" />}

                    {gd.ac.check.company.isManager() && (
                        <div className="customize">
                            <div className="ui5-ico-15 i5-wrench m-r-8" />
                            <div className="ui5-txt-link-small-no-accent lh-13em" onClick={this.onEditStatusesClick}>Edit workflow</div>
                        </div>
                    )}

                </div>


            </Popover>
        );



    }
}